import OptionalImage from '@src/components/optional-image';
import React from 'react';
import { observer } from 'mobx-react';
// import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';

// import cs from 'classnames';

import styles from './index.less';

const QrcodeModal = ({ store, onClose }) => {
  store.use(onClose);

  const renderQrcode = () => {
    if (store?.loading) {
      return <img className={styles.loading_img} src={require('../images/loading.gif')} alt="loading" />;
    }
    if (!store.qrcodeImg) return null;
    return <OptionalImage onClick={store.getQrcode} className={styles.qrcode_img} src={store.qrcodeImg} alt="二维码" />;
  };
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.content}>
        <div onClick={store.onQrcodeModalClose} className={styles.close_btn} data-name="关闭" />
        <div className={styles.qrcode_box}>{renderQrcode()}</div>
        <span onClick={store.changeToFormModal} className={styles.text_btn}>
          手机号预约 &gt;
        </span>
      </div>
    </ModalContainer>
  );
};

export default observer(QrcodeModal);
